module.exports = __webpack_public_path__ + "static/img/6.e1b03760.png";